import React from 'react';
import './NoMatch.css';
import { Link } from 'react-router-dom';

const NoMatch = props => (
    <div className="no-match animated bounce">
        <div className="error-page">
            <h2 className="headline text-yellow"> 404</h2>
            <div className="error-content">
                <h3><i className="fa fa-warning text-yellow"/> Oops! Page not found.</h3>
                <p>
                    We couldn't find the page you were searching for.
                    In the mean time, you could <Link to="/">go back to the dashboard</Link> or
                    try searching by the form.
                </p>
            </div>
        </div>
    </div>
);

export default NoMatch;



// WEBPACK FOOTER //
// ./src/pages/NoMatch/index.js